import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ExternalLink from '../external-link';
import ExternalLinkStyles from '../external-link/index.module.scss';
import YoutubeLink from '../youtube-link';
import { getYoutubeUrlDetails } from '../../helpers/youtube-url';
import { useGetHrefContext } from '../../context';
import { parseHostname } from '../../helpers/url';
import { jsx as _jsx } from "react/jsx-runtime";

const handleLinkTarget = (href, target, hostname) => {
  // Default to open link in new tab
  let linkTarget = '_blank';
  const parsedHostName = parseHostname(href); // If the link is internal, open it in the same tab

  if (target || parsedHostName === hostname || parsedHostName === null || !hostname // if there is no host or is null
  ) {
    linkTarget = '_self';
  } // Returns the results


  return linkTarget;
};

const Link = _ref => {
  let {
    title,
    href,
    children,
    target
  } = _ref;
  const youtubeDetails = getYoutubeUrlDetails(href);
  const getUrl = useGetHrefContext();
  const hostname = parseHostname(getUrl());

  if (youtubeDetails) {
    return /*#__PURE__*/_jsx(YoutubeLink, _objectSpread(_objectSpread({
      title: title
    }, youtubeDetails), {}, {
      "data-id": "link_index_Link_YoutubeLink"
    }));
  }

  const linkTarget = handleLinkTarget(href, target, hostname); // Couldn't use react-router link since some of the internal link is not registered on the router

  return /*#__PURE__*/_jsx(ExternalLink, {
    url: href,
    className: ExternalLinkStyles.ExternalLinkInText,
    target: linkTarget,
    "data-id": "link_index_Link_ExternalLink",
    children: children
  });
};

export default Link;